// import { useEffect, useState } from "react";

import { useEffect, useState } from "react";
import { Header } from "../../components/Header";
import WhatsappButton from "../../components/WhatsappButton";
import {
  MainContainer,
  Content,
  TitleContainer,
  InfoContainer,
  CardsContainer,
  OportunityCard,
  FiltersContainer,
  InputContainer,
  InputGroup,
} from "./styled";
import api from "../../api/axios";
import { toast } from "react-toastify";
import { MenuItem, Select, TextField } from "@mui/material";
import { useNavigate } from "react-router-dom";

const REGIMES = ["Presencial", "Remoto", "Híbrido"];

const Oportunidades = () => {
  const [oportunidades, setOportunidades] = useState([]);
  const [candidaturas, setCandidaturas] = useState([]);

  const [skills, setSkills] = useState([]);

  const [filters, setFilters] = useState({
    cargo: "",
    regime: "Todos",
    tecnologia: "Todos",
  });
  const [isSearching, setIsSearching] = useState(false);

  const navigate = useNavigate();

  const getOportunidades = async () => {
    try {
      const res = await api.get("/oportunity/list-short");
      setOportunidades(res.data);
    } catch (err) {
      console.error(err);
      toast.error("Ocorreu um erro:", err);
    }
  };

  const getCandidaturas = async () => {
    try {
      const res = await api.get("/application/list-applicated");
      setCandidaturas(res.data.map((item) => item.oportunity));
    } catch (err) {
      console.error(err);
      toast.error("Ocorreu um erro:", err);
    }
  };

  const getSkills = async () => {
    try {
      const res = await api.get("/skill/list");
      setSkills(res.data);
    } catch (err) {
      console.error(err);
      toast.error("Ocorreu um erro:", err);
    }
  };

  const handleSearch = async () => {
    setIsSearching(true);

    try {
      const result = await api.post("/oportunity/search-params", filters);
      setOportunidades(result.data);
    } catch (err) {
      console.error(err);
      toast.error("Ocorreu um erro na busca:", err);
    }

    setIsSearching(false);
  };

  const handleApplyClick = async (oportunity) => {
    try {
      const res = await api.get("/user/me");
      if (res.data._id) {
        navigate("/candidatar/" + oportunity._id);
      }
    } catch (err) {
      if (err.status === 401) {
        navigate("/cadastro-oportunidade/" + oportunity._id);
        return;
      }

      if (err.response?.data?.message) {
        toast.error("Ocorreu um erro: " + err.response?.data?.message);
      } else {
        toast.error("Ocorreu um erro");
      }
    }
  };

  useEffect(() => {
    getOportunidades();
    getCandidaturas();
    getSkills();
  }, []);

  return (
    <Content>
      <WhatsappButton />
      <Header />
      <MainContainer>
        <TitleContainer>
          <span>{"Conheça as nossas oportunidades:"}</span>
        </TitleContainer>
        <FiltersContainer>
          <InputGroup>
            <InputContainer>
              <label for="cargo-filtro">Cargo:</label>
              <TextField
                id="cargo-filtro"
                name="cargo-filtro"
                value={filters.cargo}
                sx={{
                  backgroundColor: "#FFF",
                  height: "50px",
                  textAlign: "start",
                  fontSize: "0.9rem",

                  "&.Mui-disabled": {
                    backgroundColor: "#f2f2f2",
                  },

                  "& .MuiSelect-select.Mui-disabled": {
                    backgroundColor: "#f2f2f2",
                  },
                }}
                onChange={(e) =>
                  setFilters({ ...filters, cargo: e.target.value })
                }
              />
            </InputContainer>
            <InputContainer>
              <label for="regime-filtro">Regime:</label>
              <Select
                id="regime-filtro"
                name="regime-filtro"
                value={filters.regime}
                sx={{
                  backgroundColor: "#FFF",
                  height: "50px",
                  textAlign: "start",
                  fontSize: "0.9rem",

                  "&.Mui-disabled": {
                    backgroundColor: "#f2f2f2",
                  },

                  "& .MuiSelect-select.Mui-disabled": {
                    backgroundColor: "#f2f2f2",
                  },
                }}
                onChange={(e) =>
                  setFilters({ ...filters, regime: e.target.value })
                }
              >
                <MenuItem value={"Todos"}>{"Todos"}</MenuItem>
                {REGIMES.map((item) => (
                  <MenuItem value={item}>{item}</MenuItem>
                ))}
              </Select>
            </InputContainer>
            <InputContainer>
              <label for="regime-filtro">Habilidades:</label>
              <Select
                id="regime-filtro"
                name="regime-filtro"
                value={filters.tecnologia}
                sx={{
                  backgroundColor: "#FFF",
                  height: "50px",
                  textAlign: "start",
                  fontSize: "0.9rem",

                  "&.Mui-disabled": {
                    backgroundColor: "#f2f2f2",
                  },

                  "& .MuiSelect-select.Mui-disabled": {
                    backgroundColor: "#f2f2f2",
                  },
                }}
                onChange={(e) =>
                  setFilters({ ...filters, tecnologia: e.target.value })
                }
              >
                <MenuItem value={"Todos"}>{"Todos"}</MenuItem>
                {skills.map((item) => (
                  <MenuItem value={item.name}>{item.name}</MenuItem>
                ))}
              </Select>
            </InputContainer>
          </InputGroup>
          <div>
            <div
              style={
                !isSearching
                  ? {
                      marginTop: "20px",
                      backgroundColor: "#104467",
                      height: "50px",
                      width: "200px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "1rem",
                      color: "white",
                      cursor: "pointer",
                      borderRadius: "5px",
                      textAlign: "center",
                    }
                  : {
                      marginTop: "20px",
                      backgroundColor: "#eee",
                      height: "50px",
                      width: "200px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "1rem",
                      color: "white",
                      cursor: "not-allowed",
                      borderRadius: "5px",
                      textAlign: "center",
                    }
              }
              onClick={handleSearch}
            >
              Pesquisar oportunidades
            </div>
          </div>
        </FiltersContainer>
        <InfoContainer>
          {oportunidades.length < 1 ? (
            <div
              style={{
                textAlign: "center",
                width: "100%",
                height: "100%",
                backgroundColor: "#edf1f6",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#104467",
                fontSize: "1.25rem",
              }}
            >
              <span>Não existem oportunidades para essa pesquisa</span>
            </div>
          ) : (
            <CardsContainer>
              {oportunidades.map((item) => (
                <OportunityCard>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      gap: "15px",
                    }}
                  >
                    <h2 style={{ color: "#104467", fontSize: "1rem" }}>
                      {item.cargo}
                    </h2>
                  </div>
                  <div
                    style={{
                      width: "100%",
                      maxHeight: "75px",
                      textAlign: "justify",
                      fontSize: "0.9rem",
                      overflowY: "auto",
                      textOverflow: "ellipsis",
                      wordBreak: "break-word",
                      overflowWrap: "break-word",
                    }}
                  >
                    <span>{`Oportunidade na empresa ${item.empresa}`}</span>
                  </div>
                  <div
                    style={{
                      marginTop: "20px",
                      backgroundColor: "white",
                      height: "35px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "0.8rem",
                      color: "#104467",
                      border: "1px solid #104467",
                      cursor: "pointer",
                      borderRadius: "5px",
                    }}
                    onClick={() => navigate("/oportunidade/" + item._id)}
                  >
                    Ver Detalhes
                  </div>
                  {candidaturas.includes(item._id) ? (
                    <div
                      style={{
                        marginTop: "5px",
                        backgroundColor: "white",
                        height: "35px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "0.8rem",
                        color: "#ccc",
                        borderRadius: "5px",
                        border: "1px solid #ccc",
                        cursor: "default",
                      }}
                    >
                      Candidatura Enviada
                    </div>
                  ) : (
                    <div
                      style={{
                        marginTop: "5px",
                        backgroundColor: "#104467",
                        height: "35px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "0.8rem",
                        color: "white",
                        cursor: "pointer",
                        borderRadius: "5px",
                      }}
                      onClick={() => handleApplyClick(item)}
                    >
                      Candidatar a esta oportunidade
                    </div>
                  )}
                </OportunityCard>
              ))}
            </CardsContainer>
          )}
        </InfoContainer>
      </MainContainer>
    </Content>
  );
};

export default Oportunidades;
